import { useState } from "react";
import { motion } from "framer-motion";
import { Plus, Minus, Question } from "@phosphor-icons/react";
import { FAQS } from "../data/content";

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-8 py-12 lg:py-20">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
        <div className="w-12 h-12 rounded-xl bg-muted flex items-center justify-center">
          <Question size={26} weight="duotone" className="text-accent" />
        </div>
        <p className="text-xs uppercase tracking-[0.2em] text-accent font-semibold mt-5">Section 2</p>
        <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tight text-foreground mt-2">
          Questions & Answers
        </h1>
        <p className="text-muted-foreground text-lg mt-4 leading-relaxed">
          Common questions about phishing and what to do when something looks off.
        </p>
      </motion.div>

      <div className="mt-10 space-y-3">
        {FAQS.map((item, i) => {
          const isOpen = open === i;
          return (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: i * 0.04 }}
              className="rounded-xl bg-white border border-border overflow-hidden"
            >
              <button
                onClick={() => setOpen(isOpen ? -1 : i)}
                data-testid={`faq-toggle-${i}`}
                className="w-full flex items-center justify-between gap-4 text-left p-5 hover:bg-muted/50 transition-colors duration-200"
              >
                <span className="font-heading font-bold text-foreground text-lg">{item.q}</span>
                <span className="shrink-0 w-8 h-8 rounded-full bg-primary/10 text-primary flex items-center justify-center">
                  {isOpen ? <Minus size={18} weight="bold" /> : <Plus size={18} weight="bold" />}
                </span>
              </button>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  className="px-5 pb-5"
                >
                  <p className="text-muted-foreground leading-relaxed">{item.a}</p>
                </motion.div>
              )}
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
